export default __webpack_public_path__ + "static/media/TITULOS_05.bc04872c.png";